import { getCurrentBundleDetails } from "@/helpers/bundle";
import { isDateInPast } from "@/helpers/date";

const getDefaultState = () => ({
  bundleList: [],
});

export default {
  namespaced: true,
  state: () => getDefaultState(),
  actions: {
    bundleList({ commit }, payload) {
      commit("bundleList", payload);
    },
    resetState({ commit }) {
      commit("resetState");
    },
  },
  getters: {
    bundleList: state => state.bundleList,
    currentBundleDetails(state, getters, rootState) {
      if (!state.bundleList.length) return null;
      return getCurrentBundleDetails(state.bundleList, rootState["currentPlanDetails"]);
    },
    bundleId(state, getters) {
      return getters.currentBundleDetails?.bundleId;
    },
    status(state, getters) {
      return getters.currentBundleDetails?.status;
    },
    isExpired(state, getters) {
      return getters.currentBundleDetails?.expiryDate
        ? isDateInPast(getters.currentBundleDetails.expiryDate)
        : false;
    },
  },
  mutations: {
    bundleList(state, payload) {
      state.bundleList = payload;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },
};
